import { useState } from 'react'
import { Box, Drawer, AppBar, Toolbar, Typography, Divider, List, ListItem, ListItemButton, 
  ListItemText, IconButton, useTheme, useMediaQuery } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import DocumentContent from './components/DocumentContent'
import { sections, Section } from './data/documentSections'

const drawerWidth = 280

export default function App() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileOpen, setMobileOpen] = useState(false)
  const [selectedSection, setSelectedSection] = useState<string>(sections[0].id)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleSectionClick = (id: string) => {
    setSelectedSection(id)
    if (isMobile) {
      setMobileOpen(false)
    }
  }

  const drawer = (
    <>
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          TTLock Adapter
        </Typography>
      </Toolbar>
      <Divider />
      <List>
        {sections.map((section: Section) => (
          <ListItem key={section.id} disablePadding>
            <ListItemButton 
              selected={selectedSection === section.id}
              onClick={() => handleSectionClick(section.id)}
            >
              <ListItemText primary={section.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  )

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            TTLock API Adapter Documentation
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      >
        {/* Mobile drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        {/* Desktop drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { md: `calc(100% - ${drawerWidth}px)` },
          marginTop: '64px',
        }}
      >
        <DocumentContent sectionId={selectedSection} />
      </Box>
    </Box>
  )
} 